import React from 'react';
import styled from 'styled-components';
import { faDollarSign, faLandmark, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { StratAndTrustPilot, GridListOption } from '../shared';
import { useSlideData } from '@context/slide-data';

const Style = styled.div`
    display: flex;
    flex-direction: ${props => props.desktop ? 'row' : 'column'};
    align-items: center;
    ${props => props.desktop && 'height: 100%;'}
    >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        ${props => props.desktop && 'width: 33%;'}
        ${props => props.desktop && 'margin: 0 40px 0 15px;'}
    }
    ul {
        padding-inline-start: 0;
        list-style-type: none;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 90%;
        margin-top: 5%;
        li {
            ${props => !props.desktop && 'padding: 5px 0;'}
        }
    }
    span {
        font-size: ${props => props.theme.smallFont};
    }
`;

export const CompanyYouCanTrust = () => {
    const { desktop } = useSlideData();
    const gridListOptions = ['individuals_helped', 'debt_resolved', 'loans', 'active_clients'];
    const icons = {
        individuals_helped: faUser,
        debt_resolved: faDollarSign,
        loans: faLandmark,
        active_clients: faUserFriends
    };

    return (
        <Style desktop={desktop}>
            <StratAndTrustPilot
                showLine={true}
                stratLogoDimensions={{ height: '170px' }}
                trustPilotDimensions={{ width: '230px' }}
            />
            <ul>
                { gridListOptions.map((option, index) => (
                    <li key={option}>
                        <GridListOption 
                            step={index + 1}
                            imageType={icons[option]}
                            name={option}/>
                    </li>
                )) }
            </ul>
        </Style>
    );
};

export default CompanyYouCanTrust;
